// extracted by mini-css-extract-plugin
module.exports = {"menu-title":"_7ER7GCNyKP4DuNoCHhFIr","menu-title-loyalty":"_3X28NbuyblbEnBWd3o8W1f","capital-logo":"_39nZkTywPkYExiJLKdhjLG","btn-apply-capital":"SRasd-9aba7HjOZPq05ct"};